/**
 * @file delimeter.component.tsx
 * @description Пункт бокового меню, который представляет из себя линию разделитель для визуального отделения групп элементов меню
 * @author AI-Generated | Human-Reviewed
 * @created 2025-09-03
 * @updated 2025-09-10
 * @dependencies []
 * @related-files []
 */

export const Delimeter = () => <div className="menuItemDelimeter w-full" />;
